<template>
  <div class="row">
    <app-overlay-loader v-if="preloader" />
    <div class="col-xl-6 mb-primary" v-for="(museum, index) in museumList" :key="index">
      <div class="card card-with-shadow border-0">

        <div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center row">
          <div class="col-12">
            <h4 class="card-title mb-0">{{ museum.name }}</h4>
          </div>
          <div class="col-12 mt-4">
            <h6>{{ museum.address }}</h6>
            <h6>{{ $t("currency") }}: <b>{{ museum.currency ? museum.currency.iso : '-' }}</b></h6>
          </div>
        </div>

        <div class="card-body">
          <button type="button" class="btn btn-secondary btn-with-shadow" data-toggle="modal" @click="openModalMuseum(museum.id)">
            {{ $t("edit") }}
          </button>
        </div>
      </div>
    </div>

    <div class="col-12">
      <button type="button" class="btn btn-primary btn-with-shadow" data-toggle="modal" @click="openModalMuseum()">
        {{ $t("add_new") }}
      </button>
    </div>

    <app-museum-modal
      v-if="museumModalActive"
      modal-id="museum-modal"
      :currency-list="currencyList"
      :selected-url="museumSelectedUrl"
      @close-modal="closeModal"
    />
  </div>
</template>

<script>
import { FormMixin } from "../../../../core/mixins/form/FormMixin.js";
import { formDataAssigner, urlGenerator } from "../../../Helpers/helpers";
import { mapGetters } from "vuex";


export default {
  name: "GeneralSetting",
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      companyLogo: false,
      companyIcon: false,
      companyBanner: false,
      museumModalActive: false,
      museumSelectedUrl: null,

      appSettings: {},
      testLanguage: [
        { id: 'ru', value: "English" },
        { id: 'en', value: "Russian" },
      ],
      dateFormats: [],
      timeFormats: [],
      timeZones: [],
      decimalSeparators: [],
      numberOfDecimals: [],
      thousandSeparators: [],
      currencyPositions: [],
      imageUrl: '',
      errors: [],
      loading: false,
      museumLocal: localStorage.getItem('museum_id') ? JSON.parse(localStorage.getItem('museum_id')) : null,
    }
  },
  methods: {
    openModalMuseum(id = null) {
      if (id) {
        this.museumSelectedUrl = `crm/museum/show/${id}`;
      } else {
        this.museumSelectedUrl = null;
      }
      this.museumModalActive = true;
    },
    closeModal() {
      this.$store.dispatch("getMuseum");
      this.museumModalActive = false;
      this.museumSelectedUrl = null;
    },
    changeValue(type) {
      if (type === 'thousand_separator') {
        if (this.appSettings.thousand_separator === ',') {
          this.appSettings.decimal_separator = '.'
        } else if (this.appSettings.thousand_separator === '.') {
          this.appSettings.decimal_separator = ','
        }
      } else {
        this.appSettings.thousand_separator = this.appSettings.decimal_separator === ',' ? '.' : ','
      }
    },
    getData() {
      this.axiosGet(`admin/app/settings`).then(response => {
        this.appSettings = response.data;
        this.appSettings.company_logo = urlGenerator(this.appSettings.company_logo);
        this.appSettings.company_icon = urlGenerator(this.appSettings.company_icon);
        this.appSettings.company_banner = urlGenerator(this.appSettings.company_banner);

      }).catch(({ error }) => {
      });
    },
    getGeneralSettings() {
      this.axiosGet(`crm/general-settings`).then(response => {
        this.currencyPositions = response.data.currency_position;
        this.dateFormats = response.data.date_format;
        this.decimalSeparators = response.data.decimal_separator;
        this.numberOfDecimals = response.data.number_of_decimal;
        this.thousandSeparators = response.data.thousand_separator;
        this.timeFormats = response.data.time_format;
        this.timeZones = response.data.time_zones;
      }).catch(({ response }) => {
      });
    },
    beforeSubmit() {
      this.loading = true;
      this.preloader = true;
    },
    submit() {
      if (this.companyLogo === false) {
        delete this.appSettings.company_logo;
      }
      if (this.companyIcon === false) {
        delete this.appSettings.company_icon;
      }
      if (this.companyBanner === false) {
        delete this.appSettings.company_banner;
      }
      let formData = formDataAssigner(new FormData, this.appSettings);
      this.save(formData);
    },
    afterSubmit() {

    },
    afterError(response) {
      this.errors = response.data.errors;
    },
    afterSuccess(res) {
      this.$toastr.s(res.data.message);
      location.reload();
    },
    afterFinalResponse() {
      this.loading = false;
      this.preloader = false;
    },
  },
  computed: {
    ...mapGetters({
      museumList: "getMuseum",
      currencyList: "getCurrency",
    }),
  },
  created() {
    this.getData();
    this.getGeneralSettings();
  },
  mounted() {
    this.$store.dispatch("getMuseum");
    this.$store.dispatch("getCurrency");
  },
}
</script>
